"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.segmentedControlTokens = void 0;
var _icon = require("../../../../forecast-v2/components/media/icon/icon.tokens");
var segmentedControlTokens = function segmentedControlTokens(theme) {
  return {
    font: {
      standard: theme.sys.font.body[1]
    },
    color: {
      font: {
        default: theme.sys.color.text.content.main,
        checked: theme.sys.color.text.content.main,
        hover: theme.sys.color.text.content.main,
        disabled: theme.sys.color.text.disabled.ondisabled
      },
      background: {
        default: theme.comp.segmentedcontrol.color.background.default,
        checked: theme.sys.color.background.neutral[1],
        hover: theme.comp.segmentedcontrol.color.background.hover,
        disabled: theme.sys.color.background.disabled[1]
      },
      icon: {
        default: _icon.tokens.color.default,
        checked: _icon.tokens.color.default,
        hover: _icon.tokens.color.default,
        disabled: _icon.tokens.color.disabled
      },
      border: {
        default: theme.sys.color.border.enabled,
        checked: theme.sys.color.border.enabled,
        disabled: theme.sys.color.border.disabled,
        error: theme.sys.color.border.error
      }
    },
    size: {
      height: '44px'
    },
    focusRing: theme.sys.color.border.focusring
  };
};
exports.segmentedControlTokens = segmentedControlTokens;